import { CookieConsentGUI } from "./CookieConsent";

window.addEventListener("DOMContentLoaded", () => CookieConsentGUI.main());
